const NativeTitleStatus = Object.freeze({
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
});

export default NativeTitleStatus;
